export enum BackgroundColor {
  DEFAULT = 'default',
  INHERIT = 'inherit',
}

export enum HoverColor {
  NONE = 'none',
  MID = 'mid',
  DARK = 'dark',
  BLUE = 'blue',
}

export enum RadioCardSelectedColor {
  NONE = 'none',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum RadioCardPadding {
  MID = 'mid',
  SMALL = 'small',
  NONE = 'none',
}
